export default __webpack_public_path__ + "static/Brochure Ezy-Medical BM-a6f0f0edd7057605fb720b91c9b50f9d.pdf";